export default __webpack_public_path__ + "static/media/174hz-healing-and-pain-relief.b91f88a8.mp3";